import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useState } from 'react';
import { Button } from '../../../../../../../components-v2/Button';
import { SocialMediaImagesPreviewModal } from '../../../../../../../components/socialMedia/SocialMediaImagesPreviewModal';
import { styleSheet } from './styles';

interface IProps {
	item: Api.TimelineEventViewModel<Api.ITimelineEvent>;
}

export const HandWrittenCardExtraContent = ({ item }: IProps) => {
	const handwrittenCard = item.toJs() as Api.IHandwrittenCard;
	const [isEnlargedImageOpen, setIsEnlargedImageOpen] = useState(false);

	if (!handwrittenCard.cardImage?.storedFile?.publicUrl || !handwrittenCard.cardContent) {
		return (
			<div>
				<p>No card image or content</p>
			</div>
		);
	}

	return (
		<div>
			<p>{handwrittenCard.cardContent}</p>

			<img
				src={handwrittenCard.cardImage.storedFile.publicUrl}
				alt='Handwritten card template'
				className={css(styleSheet.cardImage)}
			/>

			<Button onClick={() => setIsEnlargedImageOpen(true)} variant='link'>
				Enlarge image
			</Button>

			<SocialMediaImagesPreviewModal
				modalProps={{
					isOpen: isEnlargedImageOpen,
					onRequestClose: () => setIsEnlargedImageOpen(false),
				}}
				initialImageUrl={handwrittenCard.cardImage.storedFile.publicUrl || ''}
				images={[
					{
						fileName: handwrittenCard.cardImage.fileName,
						fileSize: handwrittenCard.cardImage.fileSize,
						id: handwrittenCard.cardImage.id,
						mimeType: handwrittenCard.cardImage.mimeType,
						url: handwrittenCard.cardImage.storedFile.publicUrl,
					},
				]}
				hideWhiteBackground={true}
				logoUrl={''}
			/>
		</div>
	);
};
